export default __webpack_public_path__ + "static/media/gs8-contact-health.573b7b65.png";